import type { Escaner } from "./port";
import { createNativeScanner } from "./nativeScanner";
import { createWasmScanner } from "./wasmScanner";

// ADR-012: raíz de composición del validador. Solo este archivo decide qué
// adaptador usar; `HomeScreen`/`ScannerScreen` reciben el resultado y jamás
// importan `nativeScanner`/`wasmScanner` directamente.
//
// Llamar a esta función NUNCA descarga el WASM: solo instancia el adaptador
// (`createWasmScanner()`), que difiere su import dinámico del decodificador
// hasta que se llame a `iniciar()`. Es lo que le permite a `HomeScreen` usarla al
// montar, solo para saber si hay cámara disponible, sin bajar nada.
//
// `null` = dispositivo por debajo de la matriz soportada (SPEC-302 §5): ni
// `BarcodeDetector` nativo ni `getUserMedia` para el respaldo WASM.
export function selectScanner(): Escaner | null {
  if ("BarcodeDetector" in globalThis) {
    return createNativeScanner();
  }
  if (
    typeof navigator.mediaDevices !== "undefined" &&
    typeof navigator.mediaDevices.getUserMedia === "function"
  ) {
    return createWasmScanner();
  }
  return null;
}
